import $ from 'jquery';

var Car = {
  id      : null,
  status  : null,

  updateStatus: function(options) {
    this.id = options.id;
    this.status = options.status;

    this.updateElements();
  },

  updateElements: function() {
    var result = $('.result_' + this.id);

    result.addClass(this.status);
  }
};

export default Car;



// WEBPACK FOOTER //
// ./app/webroot/javascript/modules/car.js